import * as React from 'react';
import IFooterContext from './footer.context.interface';

const defaultContext: IFooterContext = {
    isVisible: false
};

const FooterContext = React.createContext<IFooterContext>(defaultContext);
export default FooterContext;
